import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Link from '@/components/utilities/link/link';
import styles from './inspirational-search-entry-point.module.scss';

export interface InspirationalSearchEntryPointProps {
  /** The class name to apply */
  className?: string;
  /** The link to show */
  link?: Content.Components['LinkDto'] | null;
  /** The text to show */
  text?: string;
  /** The variant of the component to use */
  variant?: 'solid' | 'transparent';
}

const InspirationalSearchEntryPoint = ({
  className,
  link,
  text,
  variant = 'transparent',
}: InspirationalSearchEntryPointProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isSolid]: variant === 'solid',
      })}
    >
      <Icon className={styles.icon} name="LightBulb" />

      {link && (
        <Link className={styles.link} target={link.target} url={link.url}>
          {link.text}
        </Link>
      )}

      {text && <span className={styles.text}>{text}</span>}
    </div>
  );
};

InspirationalSearchEntryPoint.displayName = 'InspirationalSearchEntryPoint';

export default InspirationalSearchEntryPoint;
